import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActionBarType} from "../../../../shared/constants/action-bar-type.enum";
import {ActionBarConfig} from "../../../../shared/model/action-bar-config";
import {HeaderInfo} from "../../../../shared/model/header-info";
import {Customer} from "../../../../shared/model/customer";
import {UrlStatement} from "../../../../shared/model/http-model";
import {API} from "../../../../shared/apis/api";
import {HttpCustomService} from "../../../../service/http-custom.service";
import {takeUntil} from "rxjs/operators";
import {Subject} from "rxjs/Rx";
import {ActivatedRoute, Router} from "@angular/router";
import {CommonConstants} from "../../../../shared/constants/common-constants.enum";
import {RoleTypeEnum} from "../../../../shared/constants/role-type.enum";

@Component({
  selector: 'omni-meter-data',
  templateUrl: './meter-data.component.html',
  styleUrls: ['./meter-data.component.scss']
})
export class MeterDataComponent implements OnInit, OnDestroy {

  actionBarConfig: ActionBarConfig;
  headerInfo: HeaderInfo;
  customer: Customer;
  customerNo: number;
  ngUnsubscribe: Subject<any> = new Subject();

  constructor(
    private http: HttpCustomService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.customerNo = this.activatedRoute.snapshot.params.customerNo;
    this.initActionBarConfig();
    this.getCustomerInfo();
  }

  private initActionBarConfig(): void {
    this.actionBarConfig = {
      buttonBarConfigs: [
        {actionBarType: ActionBarType.CLOSE, isDisabled: localStorage.getItem(CommonConstants.ROLE_TYPE) === RoleTypeEnum.USER, customAction: true},
      ]
    };
  }

  initHeaderInfo(): void {
    this.headerInfo = new HeaderInfo();
    this.headerInfo.title = 'Thông tin KH';
    this.headerInfo.name = `Mã KH: ${this.customer.customerCode} --- Tên KH: ${this.customer.customerName}`;
  }

  getCustomerInfo() {
    const url: UrlStatement = {
      path: API.CUSTOMER_DETAIL,
      bind: {
        customerNo: {
          name: 'customerNo',
          placeholder: ':customerNo'
        }
      },
      values: {customerNo: this.customerNo}
    }
    this.http.get(url).pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
      if (res) {
        this.customer = res;
        this.initHeaderInfo();
      }
    })
  }

  close() {
    this.router.navigate([`/meter-cooperative/cooperative/${this.customer.cooperativeNo}/station/${this.customer.stationNo}/customer`]).finally();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
